import { SummarySectionProps } from './_types';

const SummarySection = ({
  startYear,
  endYear,
  transplantTotal,
  adultFlag,
}: SummarySectionProps): React.JSX.Element => {
  return (
    <>
      <h3 className="light mb-1 font-dmSans text-lg sm:text-xl sm:font-semibold">
        Total {adultFlag ? 'adult' : 'pediatric'} transplants
      </h3>
      <h2 className="heading-xl mb-4 font-dmSans">{transplantTotal}</h2>
      <p className="font-dmSans text-sm">
        Transplants reported by the centers (from January 1, {startYear} to December 31, {endYear})
      </p>
    </>
  );
};

export default SummarySection;
